import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext'; 

const Hero = () => {
  const navigate = useNavigate();
  /* Dil fonksiyonunu çekiyoruz kanka */
  const { t } = useLanguage(); 

  return (
    <section className="hero-bigma-section">
      <div className="hero-inner-container">
        
        {/* Sol Metin Alanı */}
        <div className="hero-content-left">
          <div className="hero-badge-tag">
            {t('hero.badge')}
          </div>
          
          <h1 className="hero-main-title">
            {t('hero.title')} <br /> 
            <span className="text-green">{t('hero.highlight')}</span>
          </h1>
          
          <p className="hero-sub-description">
            {t('hero.desc')}
          </p>
          
          <div className="hero-cta-buttons">
            <button className="btn-fill-green" onClick={() => navigate('/urunlerimiz')}>
              {t('hero.btnPrimary')}
            </button>
            <button className="btn-outline-green" onClick={() => window.open('/katalog.pdf', '_blank')}>
              {t('hero.btnSecondary')}
            </button>
          </div>
        </div>

        {/* Sağ Taraf - Görsel Olmayan, Renkli ve Metinli Alan */}
        <div className="hero-visual-right">
          <div className="hero-color-card">
            <p className="card-placeholder-text">
              {t('hero.cardText')}
            </p>
          </div>
          {/* Arka plandaki o yumuşak yeşil/mavi glow */}
          <div className="bg-soft-glow"></div>
        </div>

      </div>
    </section>
  );
};

export default Hero;